document.addEventListener('DOMContentLoaded', function () {

  // form id name
  const form_id = '#recruit-form';

  // Rules
  const rules = {
    lastName: { // 名前（名
      required: true
    },
    firstName: { // 名前（姓
      required: true
    },
    lastNameKana: { // 名前（メイ
      required: true
    },
    firstNameKana: { // 名前（セイ
      required: true
    },
    gender: {
      required: true
    },
    year: {
      required: true
    },
    month: {
      required: true
    },
    day: {
      required: true
    },
    zip: {
      required: true
    },
    region: {
      required: true
    },
    locality: {
      required: true
    },
    tel: {
      required: true
    },
    email: { // メールアドレス
      required: true,
      mail: true
    }
  } // rules

  const messages = {
    lastName: { // 名前（名
      required: '入力してください'
    },
    firstName: { // 名前（姓
      required: '入力してください'
    },
    lastNameKana: { // 名前（メイ
      required: '入力してください'
    },
    firstNameKana: { // 名前（セイ
      required: '入力してください'
    },
    gender: {
      required: '選択してください'
    },
    gakunen: {
      required: '選択してください'
    },
    school: {
      required: '高校生の方は必須入力です'
    },
    year: {
      required: '入力してください',
      min: '正しい生年月日を入力してください',
      max: '正しい生年月日を入力してください'
    },
    month: {
      required: '入力してください',
      min: '正しい生年月日を入力してください',
      max: '正しい生年月日を入力してください'
    },
    day: {
      required: '入力してください',
      min: '正しい生年月日を入力してください',
      max: '正しい生年月日を入力してください'
    },
    zip: {
      required: '入力してください'
    },
    region: {
      required: '入力してください'
    },
    locality: {
      required: '入力してください'
    },
    tel: {
      required: '入力してください'
    },
    email: { // メールアドレス
      required: '入力してください',
      mail: '正しいメールアドレスを入力してください'
    }
  }

  // 追加ルールの定義
  const methods = {
    tel: function tel( value, element ) {
      // 電話番号のバリデーション
      return this.optional(element) || /^\d{10,11}$/.test(value);
    },
    mail: function mail( value, element ) {
      // メールアドレスのバリデーション
      return this.optional(element) || /^([a-zA-Z0-9])+([a-zA-Z0-9\._-])*@([a-zA-Z0-9_-])+([a-zA-Z0-9\._-]+)+$/.test(value);
    }
  }

  // メソッドの追加（上記の追加ルールを適用させる）
  $.each( methods, function( key ) {
    $.validator.addMethod( key, this );
  })

  // jQuery Validation Plugin の初期化
  $( form_id ).validate({
    rules    : rules,
    messages : messages,
    // 複数項目のグループ化
    groups: {
      fullName    : 'lastName firstName',
      fullNameKana: 'lastNameKana firstNameKana',
      birth: 'year month day'
    },
    // フォーカスアウトでバリデーション
    onfocusout: function onfocusout( element )
    {
      if ( ! this.checkable( element ) ) {
        this.element( element );
      }
    },
    // エラーメッセージの表示位置
    errorPlacement: function errorPlacement( error, element )
    {
      // チェックボックス用に [] を取り除く
      const eleName = '#' + element.attr('name').replace( /\[\]/g, '' )

      if ( element.attr('name') == 'lastName' || element.attr('name') == 'firstName' ) {
        error.prependTo('#name_error');
      } else if ( element.attr('name') == 'lastNameKana' || element.attr('name') == 'firstNameKana' ) {
        error.prependTo('#kana_error');
      } else if ( element.attr('name') == 'year' || element.attr('name') == 'month' || element.attr('name') == 'day' ) {
        error.prependTo('#birth_error');
      } else {
        error.prependTo( eleName + '_error' );
      }
    },
    // submit
    submitHandler: function(form){
      const fd = $(form).serialize()
      confirmHandler( './form_confirm_modal.php', fd, form )
    }
  })

  // チェックボックスの validation 発火
  $('input[type="checkbox"]').on('click', function () {
    $('form').validate().element(this)
  })

  // 住所チェック
  $('input[name="zip"]').on('blur', function () {
    if( $('input[name="region"]').val() ){
      $('#region_error').empty()
    }
    if( $('input[name="locality"]').val() ){
      $('#locality_error').empty()
    }
  })

})

// jQuery Validation Plugin
// submitHandler
// form の確認画面を表示する
// 引数（ Ajax送信ファイル, form のデータ, jQuery Validation Pluginのコールバックデータ
//
const confirmHandler = ( _file, _fd, _form ) => {
  $.post(
    _file, _fd
  ).done(function( data ) {
    $('body').addClass('overflow')
    $('#confirm-overlay').html( data )
    $('#closeBtn').on('click', function(){
      $('#confirm-overlay').empty()
      $('body').removeClass('overflow')
    });
    $('#submitBtn').on('click', function(){
      _form.submit()
    })
  })
}
